module.exports = __webpack_public_path__ + "img/10464.f951a648.png";